import type { IsEntitledMultiple } from '@experiences/interfaces';
import { getBasePath } from '@experiences/util';

import {
    post,
    put,
} from '../utility/Requests';

export const entitlementsUrl = '/api/license/accountant/Entitlement';

export async function isEntitledMultiple({
    entitlements,
    organizationId,
    userId,
}: {
    url: string;
    entitlements: string[];
    organizationId: string;
    userId?: string;
}) {
    const entitledUrl = `/lease_/api/entitlements/${organizationId}/entitled`;
    const url = userId ? `${entitledUrl}?userId=${userId}` : entitledUrl;
    return post<IsEntitledMultiple>(url, {
        body: { EntitlementNames: entitlements },
        stripPortalPath: true,
    });
}

export async function consumeEntitlement(organizationId: string, entitlement: string) {
    const basePath = getBasePath(true);
    await put(`${basePath}/lease_/api/entitlements/${organizationId}/${organizationId}/portal/entitlement/${entitlement}`, {
        body: { },
        ignoreBasePath: true,
    });
    return true;
}
